export default "__VITE_ASSET__DH$HmtZ5__"